import { FC } from "react";
import { IconProps } from "./types";

export const SocialTwitterCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M15.922 8.084a4.72 4.72 0 0 0 1.493-.57 2.361 2.361 0 0 1-1.034 1.3c.476-.056.93-.182 1.35-.37a4.763 4.763 0 0 1-1.173 1.218c.006.1.007.202.007.304 0 3.108-2.365 6.691-6.69 6.691a6.662 6.662 0 0 1-3.606-1.056c.184.021.371.032.561.032a4.716 4.716 0 0 0 2.92-1.006 2.354 2.354 0 0 1-2.196-1.633 2.375 2.375 0 0 0 1.062-.04 2.355 2.355 0 0 1-1.887-2.307v-.029c.318.176.68.282 1.066.294a2.349 2.349 0 0 1-.728-3.14 6.676 6.676 0 0 0 4.847 2.458 2.352 2.352 0 0 1 4.008-2.146z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z"
      fill={fill}
    />
  </svg>
);
